var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeIconPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5C0.75199 3.4952 1.89718 2.2318 3.309 1.3494C4.7208 0.467 6.3443 0 8 0C9.6557 0 11.2792 0.467 12.691 1.3494C14.1028 2.2318 15.248 3.4952 16 5C15.248 6.5048 14.1028 7.7682 12.691 8.6506C11.2792 9.533 9.6557 10 8 10C6.3443 10 4.7208 9.533 3.309 8.6506C1.89718 7.7682 0.75199 6.5048 0 5ZM8 8.3311C8.866 8.3311 9.6966 7.9802 10.3089 7.3555C10.9213 6.7307 11.2653 5.8835 11.2653 5C11.2653 4.1165 10.9213 3.2693 10.3089 2.6445C9.6966 2.0198 8.866 1.6689 8 1.6689C7.134 1.6689 6.3034 2.0198 5.6911 2.6445C5.0787 3.2693 4.7347 4.1165 4.7347 5C4.7347 5.8835 5.0787 6.7307 5.6911 7.3555C6.3034 7.9802 7.134 8.3311 8 8.3311ZM8 6.6656C7.567 6.6656 7.1517 6.4901 6.8455 6.1777C6.5394 5.8654 6.3673 5.4417 6.3673 5C6.3673 4.5583 6.5394 4.1346 6.8455 3.8223C7.1517 3.5099 7.567 3.3344 8 3.3344C8.433 3.3344 8.8483 3.5099 9.1545 3.8223C9.4606 4.1346 9.6327 4.5583 9.6327 5C9.6327 5.4417 9.4606 5.8654 9.1545 6.1777C8.8483 6.4901 8.433 6.6656 8 6.6656Z",
    fill: "#7043FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIconPurple);
export default __webpack_public_path__ + "static/media/eye_icon_purple.8361b3265944ade88176862396c721e4.svg";
export { ForwardRef as ReactComponent };